export default {
  all: state => {
    return state.all
  },
  single: state => {
    return state.single
  },
  taskCount: state => {
    return state.taskCount
  },
  taskSettingsData: state => {
    return state.taskData
  },
  taskData: state => {
    return state.taskData
  }
}
